// Import util function.
import { copy } from "../../infinity-ui";

// Import variables from files.
import { defaultVariables } from "./default.variables";
import { alliantVariables } from "./alliant.variables";
import { cooleyVariables } from "./cooley.variables";
import { frbVariables } from "./frb.variables";
import { mofoVariables } from "./mofo.variables";
import { srzcVariables } from "./srzc.variables";
import { srzpVariables } from "./srzp.variables";
import { tcwVariables } from "./tcw.variables";
import { ubsVariables } from "./ubs.variables";
import { neuberVariables } from "./neuber.variables";
import { comcastVariables } from "./comcast.variables";

// Add variables to program variables object.
export const umbrellaVariables = {
    alliant: copy(alliantVariables, defaultVariables, { notExisting: true }),
    cooley: copy(cooleyVariables, defaultVariables, { notExisting: true }),
    frb: copy(frbVariables, defaultVariables, { notExisting: true }),
    mofo: copy(mofoVariables, defaultVariables, { notExisting: true }),
    srzc: copy(srzcVariables, defaultVariables, { notExisting: true }),
    srzp: copy(srzpVariables, defaultVariables, { notExisting: true }),
    tcw: copy(tcwVariables, defaultVariables, { notExisting: true }),
    ubs: copy(ubsVariables, defaultVariables, { notExisting: true }),
    neuber: copy(neuberVariables, defaultVariables, { notExisting: true }),
    comcast: copy(comcastVariables, defaultVariables, { notExisting: true })
};
